import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { DayPicker, DateRange } from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import logoImg from '../../assets/images/logos/ai-measure-logo-black.svg'
import searchIcon from '../../assets/images/icons/search-icon.svg'
import logoutIcon from '../../assets/images/icons/logout-icon.svg'
import toyoshimaLogo from '../../assets/images/logos/toyoshima-hd.svg'
import downArrowIcon from '../../assets/images/icons/downArrow.svg'
import upArrowIcon from '../../assets/images/icons/upArrow.svg'
import qrLittleIcon from '../../assets/images/icons/littleQr.svg'
import infoIcon from '../../assets/images/icons/info-outline.svg'
import checkIcon from '../../assets/images/icons/checkGreen.svg'
import checkboxIcon from '../../assets/images/icons/checked_checkbox.svg'
import uncheckIcon from '../../assets/images/icons/uncheck_checkbox.svg'
import filterDownIcon from '../../assets/images/icons/arrow-down.svg'
import humanIcon from '../../assets/images/icons/human.svg'
import { Modal } from '../../components/Modal'
import { useNavigate } from 'react-router-dom'
import { formatOrdinal, PATH_INFO } from '../utils/helper'
import isEqual from 'lodash/isEqual'
import { SamplesContext, UpdateSamplesContext } from '../../context/samplesContext'
import { UpdateUserContext, UserContext } from '../../context/userContext'
import { format, parse, parseISO } from 'date-fns'
import { FilterInput } from '../../components/input/FilterInput'
import { FilterParams } from '../../context/samplesContext'
import { ja } from 'date-fns/locale'
import InfiniteScroll from 'react-infinite-scroll-component'
import ReactLoading from 'react-loading'

export function Header() {
  const { user, isAuth } = useContext(UserContext)
  const { refreshUser } = useContext(UpdateUserContext)
  const [isOpen, setIsOpen] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const [isSmall, setIsSmall] = useState(false)

  const navigate = useNavigate()

  const onLogout = useCallback(() => {
    navigate(PATH_INFO.LOGIN.PATH)
    sessionStorage.removeItem('token')
  }, [navigate])

  useEffect(() => { refreshUser() }, [refreshUser])

  useEffect(() => {
    const media = window.matchMedia("(max-width: 920px)") //"tablet-lg": "920px",
    const listener = () => setIsSmall(media.matches)

    listener()
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [])

  useEffect(() => {
    if (isSmall && isOpen) {
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      return () => {
        document.body.style.overflow = originalOverflow
      }
    }
    document.body.style.overflow = ''
  }, [isSmall, isOpen])

  return (
    <div className="flex justify-between items-center h-[50px] px-5 min-w-[768px] bg-[linear-gradient(90deg,_#9E7BDB_0%,_#8C92D6_61%,_#74C8CC_100%)] sticky top-0 z-40 desktop-xmd:relative tablet-lg:px-10 tablet-lg:h-[70px]">
      <img src={logoImg} alt='logo' className='h-[34px] tablet-lg:h-[48px]' />
      <div className='flex space-x-[15px] items-center'>
        <div className='bg-white w-[356px] h-[36px] rounded-[50px] tablet-lg:h-[50px]'>
          <button
            onClick={() => { isAuth && setIsModalOpen(true) }}
            className={`flex items-center justify-between pl-[20px] w-full h-full ${!isAuth && 'cursor-not-allowed'}`}
          >
            <span className='text-gray-400 text-[14px]'>表示する品番を選択</span>
            <span className='flex justify-center items-center bg-black h-[30px] w-[30px] rounded-[50%] mr-[5px] select-none tablet-lg:w-[40px] tablet-lg:h-[40px]'>
              <img src={searchIcon} alt='' className='w-4 h-4 tablet-lg:h-5 tablet-lg:w-5' />
            </span>
          </button>
        </div>
        {isSmall ? (
          <div>
            <div
              className='flex items-center justify-center w-[30px] h-[30px] bg-black rounded-[50%]'
              onClick={() => { if (isAuth) setIsOpen((prev) => !prev) }}
            >
              <img src={humanIcon} alt='human' />
            </div>
            {isOpen && (
              <div
                className='fixed top-[50px] left-0 right-0 bottom-0 bg-black/50 z-[999]'
                onClick={() => setIsOpen(false)}
              >
                <div
                  className='absolute top-[10px] right-5 bg-white rounded-lg shadow-[0px_6px_12px_rgba(0,0,0,0.25)] w-[225px] h-[318px]'
                  onClick={(event) => event.stopPropagation()}
                >
                  <div className='flex flex-col items-center w-full h-full px-2.5 pt-[30px] text-xs'>
                    <p className='w-full text-center truncate'>{user.email}</p>
                    <p className='w-full text-center truncate'>{user.department_name}</p>
                    <div className="flex flex-col mt-4">
                      <button onClick={onLogout} className='flex items-center w-[205px] h-[42px] rounded-[3px] mt-[10px]' style={{ boxShadow: ' 0px 0px 4px 0px #00000040' }}>
                        <img src={logoutIcon} alt='logout' className='w-[32px] h-[32px] ml-[10px]' />
                        <span className='ml-[5px] text-base'>Logout</span>
                      </button>
                    </div>
                    <img src={toyoshimaLogo} alt="Logo" className="mt-[140px]" />
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={`relative inline-block bg-white w-[270px] h-[50px] z-20 select-none ${isOpen ? 'rounded-t-[5px]' : 'rounded-[5px]'}`}>
            <div
              className={`flex items-center justify-between w-full h-full pl-[10px] pr-[20px] ${isAuth ? 'cursor-pointer' : 'cursor-not-allowed'}`}
              onClick={() => { if (isAuth) setIsOpen((prev) => !prev) }}
            >
              <div className='w-[200px]'>
                <p className="text-[14px] truncate">{user.email}</p>
                <p className='text-[12px] truncate'>{user.department_name}</p>
              </div>
              {isOpen ? (<img src={upArrowIcon} alt='arrow' />) : (<img src={downArrowIcon} alt='arrow' />)}
            </div>
            {isOpen && (
              <div className="absolute flex flex-col items-center justify-between top-full left-0 bg-white z-10 w-[270px] h-[270px] rounded-b-[5px]" style={{ boxShadow: ' 0px 6px 4px 0px #00000040' }}>
                <div className="flex flex-col">
                  <span className='border-t-[1px] border-[#F3F3F3] w-[250px]'></span>
                  <button onClick={onLogout} className='flex items-center w-[250px] h-[50px] rounded-[3px] mt-[10px]' style={{ boxShadow: ' 0px 0px 4px 0px #00000040' }}>
                    <img src={logoutIcon} alt='logout' className='w-[32px] h-[32px] ml-[10px]' />
                    <span className='ml-[5px]'>Logout</span>
                  </button>
                </div>
                <img src={toyoshimaLogo} alt="Logo" className="mb-[40px]" />
              </div>
            )}
          </div>)}
      </div>
      <SearchModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  )
}

const SEARCH_MODAL_SCROLL_ID = "search-modal-scroll-container"

function SearchModal({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
  const { isAuth } = useContext(UserContext)
  const { samples, sample, rowSample, samplesMeta } = useContext(SamplesContext)
  const { refreshSamples, loadMoreSamples, idSearchSample, fetchQrCode } = useContext(UpdateSamplesContext)
  const [selectIndex, setSelectIndex] = useState<number>()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = useCallback(() => { setIsModalOpen(true) }, [])
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const [qrCodeUrl, setQrCodeUrl] = useState({ qr_code: '', url: '', id: '' })
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const openConfirmModal = useCallback(() => { setIsConfirmModalOpen(true) }, [])
  const closeConfirmModal = useCallback(() => { setIsConfirmModalOpen(false) }, [])
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
  const openFilterModal = useCallback(() => { setIsFilterModalOpen(true) }, [])
  const closeFilterModal = useCallback(() => { setIsFilterModalOpen(false) }, [])

  const [sortedSamples, setSortedSamples] = useState(samples)

  useEffect(() => {
    if (Array.isArray(samples)) {
      const sorted = samples.slice().sort((a, b) => {
        const dateA = new Date(a.created_at).getTime()
        const dateB = new Date(b.created_at).getTime()
        return dateB - dateA // 降順でソート
      })
      setSortedSamples(sorted)
    }
  }, [samples])

  useEffect(() => {
    if (!isAuth) return
    refreshSamples()
  }, [refreshSamples, isAuth])

  const onSetItem = useCallback(() => {
    if (selectIndex === undefined || samples === undefined) return
    idSearchSample(sortedSamples[selectIndex].id, true, true)
    onClose()
  }, [sortedSamples, samples, selectIndex, onClose, idSearchSample])

  const handleSetItem = useCallback(() => {
    if (sample || rowSample) {
      const hasChanged = !isEqual(sample, rowSample)
      if (hasChanged) {
        openConfirmModal()
        return
      }
    }
    onSetItem()
  }, [onSetItem, openConfirmModal, rowSample, sample])

  const handleApplyFilter = useCallback((filters: FilterParams) => {
    refreshSamples(filters);
    closeFilterModal();
  }, [refreshSamples, closeFilterModal]);

  const handleShowQrCode = useCallback(async (sampleId: string) => {
    const qrData = await fetchQrCode(sampleId);
    if (qrData) {
      setQrCodeUrl(qrData);
      openModal();
    }
    // エラーの場合は fetchQrCode 内でコンソールに出力される
  }, [fetchQrCode, openModal]);

  const formatDateParts = useCallback((value?: string | null) => {
    if (!value) {
      return null;
    }
    try {
      const formatted = format(parseISO(value), 'yyyy/MM/dd HH:mm', { locale: ja });
      const [datePart, timePart] = formatted.split(' ');
      return { datePart, timePart };
    } catch (error) {
      console.error('Failed to format sample date', error);
      return null;
    }
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[1266px] px-[21px] pt-[14px] pb-[30px] max-h-[90vh] flex flex-col'>
      <div className='flex items-center w-full'>
        <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
        <span className='text-[#3E3E3E] text-[16px]'>
          品番検索一覧
        </span>
      </div>
      <div className='flex justify-end w-full mt-[20px]'>
        <button
          onClick={openFilterModal}
          className='flex items-center justify-center w-[160px] h-[47px] border-[2px] border-[#C5C7FF] rounded-[50px] hover:bg-[#C5C7FF] transition-colors'
        >
          <img src={filterDownIcon} alt='sort' className='w-[22px] h-[22px] mr-[5px]' />
          <span className='font-semibold text-[14px] text-[#545899]'>絞り込み</span>
        </button>
      </div>
      <div
        id={SEARCH_MODAL_SCROLL_ID}
        className='flex-1 min-h-0 max-h-[650px] overflow-y-scroll mt-[20px] border-b'
      >
        <InfiniteScroll
          dataLength={sortedSamples?.length ?? 0}
          next={loadMoreSamples}
          hasMore={samplesMeta.hasMore}
          loader={
            <div className='flex items-center justify-center py-3 text-center text-xs text-[#666666]'>
              <ReactLoading type='spin' color='#666666' height={16} width={16} className='inline-block mr-2' />
              <span>読み込み中です…</span>
            </div>
          }
          endMessage={<div className='py-3 text-center text-xs text-[#666666]'>すべてのデータを読み込み済みです。</div>}
          scrollableTarget={SEARCH_MODAL_SCROLL_ID}
          scrollThreshold='200px'
          style={{ overflow: 'visible' }}
        >
          <table className='w-full h-full overflow-auto text-[#666666]'>
            <thead className='sticky top-0'>
              <tr className='[&>th]:bg-[#3E3E3E] [&>th]:text-white [&>th]:font-normal [&>th]:text-xs [&>th]:border desktop-xmd:[&>th]:text-sm'>
                <th className='sticky top-0 w-[43px] h-[39px]'>No</th>
                <th className='sticky top-0 w-[88px]'>選択</th>
                <th className='sticky top-0 w-[145px]'>日付</th>
                <th className='sticky top-0 w-[145px]'>品番</th>
                <th className='sticky top-0 w-[173px]'>サンプルNo</th>
                <th className='sticky top-0 w-[173px]'>サンプル状況</th>
                <th className='sticky top-0 w-[100px]'>リピート</th>
                <th className='sticky top-0 w-[100px]'>サイズ</th>
                <th className='sticky top-0 w-[130px]'>カラーNo</th>
                <th className='sticky top-0 w-[130px]'>デバイス名</th>
                <th className='sticky top-0 w-[145px]'>QR Cord 確認</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(samples) && sortedSamples?.map((sample, index) => (
                <tr key={index}>
                  <td className='h-[35px] border text-center'>{index + 1}</td>
                  <td className='border'>
                    <div className='flex items-center justify-center w-full h-full'>
                      <label className='cursor-pointer'>
                        <input
                          type="radio"
                          name='check'
                          className='hidden peer'
                          onChange={() => setSelectIndex(index)}
                        />
                        <img src={uncheckIcon} alt='uncheck' className='block peer-checked:hidden w-4 h-4 desktop-xmd:w-5 desktop-xmd:h-5' />
                        <img src={checkboxIcon} alt='checked' className='hidden peer-checked:block w-4 h-4 desktop-xmd:w-5 desktop-xmd:h-5' />
                      </label>
                    </div>
                  </td>
                  <td className='border text-xs text-center px-1 desktop-xmd:text-sm'>
                    {(() => {
                      const parts = formatDateParts(sample.created_at);
                      if (!parts) {
                        return '-';
                      }
                      return (
                        <span className='flex flex-col items-center justify-center leading-tight desktop-xmd:flex-row desktop-xmd:space-x-1 desktop-xmd:leading-normal'>
                          <span className='whitespace-nowrap'>{parts.datePart}</span>
                          {parts.timePart && <span className='whitespace-nowrap'>{parts.timePart}</span>}
                        </span>
                      );
                    })()}
                  </td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.part_number || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.sample_number || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.kind === 'final' ? 'FINAL' : sample.time !== 0 ? formatOrdinal(sample.time) : '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.repeat || '-'}</td>
                  <td className='border text-[16px] text-center px-1 break-words break-all'>{sample.size || '-'}</td>
                  <td className='border text-[14px] text-center px-1 break-words break-all'>{sample.color_no || '-'}</td>
                  <td className='border text-xs text-center px-1 w-[130px] break-words break-all desktop-xmd:text-sm'>
                    {sample.device_name || sample.device_location ? (
                      <span className='flex flex-wrap justify-center gap-x-1 text-center w-full'>
                        {sample.device_name && <span className='break-all'>{sample.device_name}</span>}
                        {sample.device_location && (
                          <span className='break-all text-[10px]'>{`(${sample.device_location})`}</span>
                        )}
                      </span>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className='border'>
                    <div className='flex items-center justify-center w-full h-full'>
                      <button
                        className='flex items-center justify-center w-[90px] h-[27px] rounded-[50px] bg-[#8A8A8A]'
                        onClick={() => handleShowQrCode(sample.id)}
                      >
                        <img src={qrLittleIcon} alt='qr' className='w-[12px]' />
                        <span className='text-white text-[11px] -mt-[2px] ml-[2px]'>QR表示</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              <tr>
                <td className='border h-full'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border'></td>
                <td className='border-b'></td>
                <td className='border-x border-b'></td>
              </tr>
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
      <div className='flex items-center justify-center w-full space-x-[10px] mt-[20px]'>
        <button
          className='w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={onClose}
        >
          戻る</button>
        <button
          className='w-[160px] h-[47px] bg-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={handleSetItem}
        >
          採寸表示
        </button>
      </div>
      <FilterModal isOpen={isFilterModalOpen} onClose={closeFilterModal} onApplyFilter={handleApplyFilter} />
      <QrCordModal isOpen={isModalOpen} onClose={closeModal} qrCodeUrl={qrCodeUrl} />
      <ConfirmModal isOpen={isConfirmModalOpen} onClose={closeConfirmModal} onSetItem={onSetItem} />
    </Modal>
  )
}

function FilterModal({ isOpen, onClose, onApplyFilter }: { isOpen: boolean, onClose: () => void, onApplyFilter: (filters: FilterParams) => void }) {
  const [range, setRange] = useState<DateRange | undefined>()
  const [userName, setUserName] = useState<string>('')
  const [partNumber, setPartNumber] = useState<string>('')
  const [sampleStatus, setSampleStatus] = useState<string>('')
  const [brandName, setBrandName] = useState<string>('')
  const [size, setSize] = useState<string>('')
  const [colorNo, setColorNo] = useState<string>('')

  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = parse(e.target.value, 'yyyy-MM-dd', new Date())
    if (!isNaN(date.getTime())) {
      setRange((prev) => ({ from: date, to: prev?.to }))
    } else {
      setRange((prev) => ({ from: undefined, to: prev?.to }))
    }
  }

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = parse(e.target.value, 'yyyy-MM-dd', new Date())
    if (!isNaN(date.getTime())) {
      setRange((prev) => ({ from: prev?.from, to: date }))
    } else {
      setRange((prev) => ({ from: prev?.from, to: undefined }))
    }
  }

  const handleApplyFilter = useCallback(() => {
    const filters: FilterParams = {
      userName: userName || undefined,
      partNumber: partNumber || undefined,
      sampleStatus: sampleStatus || undefined,
      brandName: brandName || undefined,
      size: size || undefined,
      colorNo: colorNo || undefined,
      createdFrom: range?.from,
      createdTo: range?.to,
    };
    onApplyFilter(filters);
    onClose();
  }, [userName, partNumber, sampleStatus, brandName, size, colorNo, range, onApplyFilter, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[793px] h-[600px] p-[20px] bg-[#FBFBFB] relative'>
      <div className='flex flex-col'>
        <div className='flex items-center'>
          <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
          <span className='text-[#3E3E3E] text-[16px]'>
            絞り込み検索
          </span>
        </div>
        <p className='text-sm text-gray-600 mt-[20px] mb-[10px] ml-[20px]'>撮影日 ※どちらか一つでも検索できます</p>
        <div className='flex flex-row space-x-[10px] w-full'>
          <div className='w-full'>
            <div className='flex items-center justify-between w-full mb-[10px]'>
              <FilterInput
                type='date'
                value={range?.from ? format(range.from, 'yyyy-MM-dd') : ''}
                onChange={handleStartDateChange}
                width='150'
              />
              <span>-</span>
              <FilterInput
                type='date'
                value={range?.to ? format(range.to, 'yyyy-MM-dd') : ''}
                onChange={handleEndDateChange}
                width='150'
              />
            </div>
            <div className='flex justify-center w-full pt-[15px] px-[15px] pb-[25px] bg-white shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)] rounded-[8px]' >
              <DayPicker
                mode="range"
                selected={range}
                onSelect={setRange}
                numberOfMonths={1}
                navLayout='around'
                formatters={{
                  formatWeekdayName: (date) => format(date, 'EEE').toUpperCase(),
                }}
              />
            </div>
          </div>
          <div className='flex flex-col w-full space-y-[10px]'>
            <FilterInput label='ユーザー' placeholder='名前' value={userName} onChange={(e) => setUserName(e.target.value)} />
            <FilterInput label='品番' placeholder='品番' value={partNumber} onChange={(e) => setPartNumber(e.target.value)} />
            <FilterInput label='サンプル状況' placeholder='1st/2nd/3rd' value={sampleStatus} onChange={(e) => setSampleStatus(e.target.value)} />
            <FilterInput label='顧客名' placeholder='顧客名' value={brandName} onChange={(e) => setBrandName(e.target.value)} />
            <FilterInput label='サイズ' placeholder='S/M/L' value={size} onChange={(e) => setSize(e.target.value)} />
            <FilterInput label='カラー' placeholder='color' value={colorNo} onChange={(e) => setColorNo(e.target.value)} />
          </div>
        </div>
        <div className='absolute bottom-[20px] right-[20px] flex justify-end mt-6'>
          <button
            className='w-[160px] h-[47px] flex items-center justify-center space-x-[5px] rounded-[50px] text-[#545899] font-semibold text-[14px] bg-white border-[2px] border-[#C5C7FF] hover:bg-[#C5C7FF] transition-colors'
            onClick={handleApplyFilter}
          >
            <img src={filterDownIcon} alt='' />
            <span>絞り込み</span>
          </button>
        </div>
      </div>
    </Modal>
  )
}

function QrCordModal({ isOpen, onClose, qrCodeUrl }: { isOpen: boolean, onClose: () => void, qrCodeUrl: { qr_code: string, url: string, id: string } }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const openModal = useCallback(() => { setIsModalOpen(true) }, [])
  const closeModal = useCallback(() => { setIsModalOpen(false) }, [])
  const inputRef = useRef<HTMLInputElement>(null)

  const onCopyUrl = useCallback(async () => {
    if (inputRef.current) {
      inputRef.current.select()
      try {
        await navigator.clipboard.writeText(inputRef.current.value)
      } catch (error) {
        console.error('リンクのコピーに失敗しました。')
      }
      openModal()
    }
  }, [openModal])

  const onQrDownload = useCallback(async (id: string) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/client/samples/${id}/qr-code/download`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })

      if (!res.ok) throw new Error('ダウンロード失敗')

      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = `qr_${id}.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)

      window.URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      console.log('DOWNLOAD ERROR')
    }
  }, [])

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='flex flex-col items-center w-[485px] h-[90vh] min-h-0 max-h-[620px] pt-5 px-5'>
      <div className='flex items-center w-full'>
        <div className='w-2 h-[35px] rounded-sm bg-[#3E3E3E] mr-[5px]' ></div>
        <span className='text-[#3E3E3E] text-[16px]'>
          QR CODE
        </span>
      </div>
      <div className='flex items-center justify-center min-w-0 max-w-[393px] min-h-0 max-h-[381px] border-[2.5px] border-[#D9D9D9] rounded-[20px] mt-[8px] overflow-hidden'>
        <img src={qrCodeUrl.qr_code} alt='qrcode' className='min-w-0 min-h-0 w-[332px] h-[355px] max-w-full max-h-full object-contain' />
      </div>
      <div className='flex items-center w-[445px] h-[40px] border-[2.5px] border-[#D9D9D9] rounded-[10px] mt-[8px]'>
        <input className='text-[16px] h-full w-full rounded-[10px] px-[18px]' ref={inputRef} value={qrCodeUrl.url} readOnly />
      </div>
      <div className='flex w-full justify-between items-center mt-[28px]'>
        <div className='relative group'>
          <span className={[
            'flex',
            'items-center',
            'justify-center',
            'w-[446px]',
            'h-[92px]',
            'px-[19px]',
            'absolute',
            'bg-white',
            'text-[14px]',
            '-translate-x-1/2',
            'left-1/2',
            'bottom-[-100px]',
            'opacity-0',
            'group-hover:opacity-100',
            'transition',
            "pointer-events-none"
          ].join(" ")} style={{ boxShadow: '0px 0px 4px 0px #00000040' }}>
            コードをスキャンするには、スマートフォンのQRスキャンアプリまたはカメラアプリを使用してください。
          </span>
          <img src={infoIcon} alt='info' className='w-6 h-6 cursor-help' />
        </div>
        <div className='space-x-[9px] pb-2'>
          <button
            className='w-[105px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] text-[16px] font-semibold'
            onClick={onCopyUrl}
          >
            コピー
          </button>
          <button
            className='w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] text-[16px] font-semibold'
            onClick={() => { onQrDownload(qrCodeUrl.id) }}
          >
            ダウンロード
          </button>
        </div>
      </div>
      <MessageModal isOpen={isModalOpen} onClose={closeModal} />
    </Modal>
  )
}

function MessageModal({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {

  return (
    <Modal isOpen={isOpen} onClose={onClose} className='flex items-center justify-center w-[414px] h-[130px]'>
      <img src={checkIcon} alt='check' className='w-6 h-6 mr-[5px]' />
      <span className='text-[14px]'>リンクをコピーしました。</span>
    </Modal>
  )
}

function ConfirmModal({ isOpen, onClose, onSetItem }: { isOpen: boolean, onClose: () => void, onSetItem: () => void }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className='w-[500px] h-[200px] flex flex-col items-center justify-center'>
      <span className='text-center'>
        <p>変更内容が保存されていません。</p>
        <p>変更内容が失われますがよろしいですか？</p>
      </span>
      <div className='mt-[25px] space-x-[25px]'>
        <button
          className='w-[160px] h-[47px] border-[1.5px] border-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={onClose}
        >
          戻る
        </button>
        <button
          className='w-[160px] h-[47px] bg-[#C5C7FF] rounded-[50px] text-[#545899] font-semibold text-[14px]'
          onClick={() => {
            onSetItem()
            onClose()
          }}
        >
          OK
        </button>
      </div>
    </Modal>
  )
}
